export const methods = (state) => ({
  setNutzungsgradData(data, type) {
    const { topFlopNutzungsgradTable } = state.centralHeatings.dashboard;
    topFlopNutzungsgradTable[type] = data;
  },
});
